import styled, {
    withTheme
} from 'styled-components';

export const SearchInput = styled.input `
    background: ${ ({ theme: { inputBackground } }) => inputBackground };
    border: 1px solid ${ ({ theme: { chatInputBorder } }) => chatInputBorder };
    border-radius: 8px;
    box-sizing : border-box;
    color: ${ ({ theme: { textColor } }) => textColor };
    font-family: 'Montserrat', sans-serif;
    font-size: ${ ({ fontSize }) => fontSize || 'rem' };
    font-weight: normal;
    margin-left: 0;
    margin-right: 0;
    outline: none;
    padding: 10px;
    width: ${ ({ width }) => width || '100%' };

    &:disabled {
      background-color: ${ ({ theme: { inputDisabledBackground } }) => inputDisabledBackground };
      color: ${ ({ theme: { inputDisabledColor } }) => inputDisabledColor };
    }

    &::placeholder{
        color: ${ ({ theme: { opacityColor } }) => opacityColor };
        font-weight: normal;
    }
`;
SearchInput.displayName = 'SearchInput';

export const Container = styled.div `
    box-sizing: border-box;
    left: 0;
    padding: 10px;
    overflow: auto;
    width: 100%;
    min-height: ${ ({ onlyShow }) => onlyShow ? 'calc( 43% - 90px)' : '100%' } ;
    max-height: ${ ({ onlyShow }) => onlyShow ? 'calc( 43% - 90px)' : '100%' } ;
`;
Container.displayName = 'Container';

export const InputContainer = styled.div `
    width: 90%;
`;
InputContainer.displayName = 'InputContainer';

const FormWrapperStyled = styled.form `
    background-color: ${ ({ theme: { chatFormWrapper } }) => chatFormWrapper };
    bottom: 0;
    left: 0;
    height: 50px;
    width: 100%;
    padding: 10px 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .video_call_btn{
        padding: 8px;
    }
    input{
        border: none;
        font-size: 13px;
        margin: 0;
        padding: 10px;
    }
`;
export const FormWrapper = withTheme(FormWrapperStyled);
FormWrapper.displayName = 'FormWrapper';
